import { render, staticRenderFns } from "./create-new-ticket.vue?vue&type=template&id=77240000&scoped=true"
import script from "./create-new-ticket.vue?vue&type=script&lang=js"
export * from "./create-new-ticket.vue?vue&type=script&lang=js"
import style0 from "./create-new-ticket.vue?vue&type=style&index=0&id=77240000&prod&lang=scss"
import style1 from "./create-new-ticket.vue?vue&type=style&index=1&id=77240000&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77240000",
  null
  
)

export default component.exports